/**
 * Created by osirvent on 09/05/2017.
 */
angular
    .module('annexaApp')
    .component('annexaLinkValue', {
        transclude: true,
        templateUrl: './components/common/annexa-link-value/annexa-link-value.html',
        controller: ['$state', function ($state) {
            var vm = this;

            this.$onInit = function () {
            	if(!vm.showLabelAux) {
                    vm.showLabelAux = false;
                }
            	if(!vm.label) {
                    vm.label = 'label';
                }
                if(!vm.labelAux) {
                    vm.labelAux = '';
                }
                if(!vm.link) {
                    vm.link = 'link';
                }
                if(!vm.param) {
                    vm.param = undefined;
                }
                if(!vm.linkUrl) {
                    vm.linkUrl = undefined;
                }
            };
            
            vm.getLinkUrl = function(paramId){
            	if (paramId) {
            		return $state.href(vm.link, { objectId: paramId });
            	} else {
            		return $state.href(vm.link, {});
            	}
            };
            
            this.$onChanges = function (changes) {
            	if (changes.param) {
            		vm.linkUrl = vm.getLinkUrl(changes.param.currentValue);
            	}
            };
        }],
        bindings: {
        	labelAux: '@',
            label: '@',
            link: '@',
            param: '@',
            showLabelAux: '@?'
        }
    })